import $ from 'jquery';
import 'slick-carousel';

function slider_with_thumbnails($slider, arrows) {
	let $slides = $slider.find('.slider__slides');

	if ( arrows == undefined ) {
		arrows = false;
	}

	$slides.slick({
		dots: true,
		arrows: arrows,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 1000,
		centerMode: false,
		variableWidth: false,
		adaptiveHeight: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
		customPaging : function(slider, i) {
			var thumb = $(slider.$slides[i]).find('.slider__slide').data('thumb');
			var alt = $(slider.$slides[i]).find('.slider__slide').data('alt').toLowerCase();
			return '<a class="color-'+ alt +'" style="background-image: url('+ thumb +'); "></a>';
		},
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
					fade: false
				}
			}
		]
	});
}

export default slider_with_thumbnails;
